import { render, staticRenderFns } from "./bscOrderMainOtd.vue?vue&type=template&id=1ff93303&scoped=true"
import script from "./bscOrderMainOtd.vue?vue&type=script&lang=js"
export * from "./bscOrderMainOtd.vue?vue&type=script&lang=js"
import style0 from "./bscOrderMainOtd.vue?vue&type=style&index=0&id=1ff93303&prod&lang=css"
import style1 from "./bscOrderMainOtd.vue?vue&type=style&index=1&id=1ff93303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff93303",
  null
  
)

export default component.exports